import React from 'react';
import { useLocation } from 'react-router-dom';
import { prop } from 'ramda';

import { useAppSelector } from 'js/store/hooks';
import { isExternalUrl, redirect } from 'js/utils/url.util';
import { Redirect as CoreRedirect } from 'js/components/common/Redirect/Redirect';

export const Redirect = ({ ...attribs }) => {
    const rootPage = useAppSelector(prop('rootPage'));
    const toPage = attribs.to === rootPage ? '/' : attribs.to;
    const location = useLocation();
    const isRedirectToOurSite = toPage.includes(window.location.hostname);

    if (location.search && isRedirectToOurSite && isExternalUrl(toPage)) {
        redirect(`${toPage}${location.search}`, attribs.isReplace);

        return null;
    }

    return <CoreRedirect {...attribs} to={toPage} />;
};
